import { createTheme } from '@mui/material/styles'

/**
 * MUI theme for Farmschool.
 * Brand palette mirrors the mobile app's warm green + cream aesthetic.
 */
export const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32',       // forest green
      light: '#4CAF50',
      dark: '#1B5E20',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#795548',       // warm brown
      light: '#A1887F',
      dark: '#4E342E',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#C62828',
    },
    success: {
      main: '#2E7D32',
      light: '#C8E6C9',
    },
    background: {
      default: '#FFF8F0',    // warm cream — matches mobile background
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A1A1A',
      secondary: '#5D4037',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCard: {
      defaultProps: {
        elevation: 1,
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1B5E20',
          color: '#FFFFFF',
        },
      },
    },
  },
})
